  /* Яндекс.Карта для сайта */
  if ( typeof ymaps !== 'undefined' && document.getElementById('map') ) {
    ymaps.ready(function(){
      var map = new ymaps.Map('map', {
        center: [54.776918, 56.031311],
        zoom: 16,
        controls: ['zoomControl']
      });
      var placemark1 = new ymaps.Placemark(map.getCenter(), {
        hintContent: 'Уфа — пр. Октября 132/3, офис 1203',
        balloonContent: 'Уфа — пр. Октября 132/3, офис 1203',
      }, {
        iconLayout: 'default#image',
        iconImageHref: '/wp-content/themes/sintera/assets/images/sintera-map-logo.svg',
        iconImageSize: [40, 40],
        iconImageOffset: [-20, -20]
      });
      var placemark2 = new ymaps.Placemark([53.618536, 55.908808], {
        hintContent: 'Стерлитамак — Коммунистическая 85а, офис 209',
        balloonContent: 'Стерлитамак — Коммунистическая 85а, офис 209',
      }, {
        iconLayout: 'default#image',
        iconImageHref: '/wp-content/themes/sintera/assets/images/sintera-map-logo.svg',
        iconImageSize: [40, 40],
        iconImageOffset: [-20, -20]
      });
      map.behaviors.disable('scrollZoom'); // Убираем увеличение карты при скролинге
      map.geoObjects.add(placemark1);
      map.geoObjects.add(placemark2);
    });
  }
  /* -- Яндекс.Карта для сайта -- */